import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { ArticleHeader } from '@cinch-nx/landing-ui-articles'
import { Head } from '@cinch-nx/landing-ui-shared'
import { Wrapper } from '@cinch-nx/shared-ui'

import styles from './articles-sub-hub.module.css'
import { ArticlesCardsList, Pagination } from './components'
import type { StaticProps } from './get-static-props'

export function ArticleSubHubFeature({
  story,
  path,
  preview,
  generatedAt,
  currentPage,
  numberOfArticles,
  resultsPerPage,
  articles,
}: StaticProps) {
  const { content } = useStoryblokState({ story, enableBridge: preview })
  const { title, description } = content ?? {
    title: 'Loading',
    description: 'Loading...',
  }
  const [SEO] = content?.SEO ?? [{}]

  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle="Cars Without The Faff - cinch"
        fallbackDescription="Welcome to cinch, the faff free way to buy & sell cars. We have thousands of used cars, ready to be sold to you."
      />

      <article className={styles.page} data-testid={`articles-sub-hub-${path}`}>
        <Wrapper isSlim>
          <ArticleHeader title={title} subTitle={description} />
          <ArticlesCardsList
            path={path}
            articles={articles}
            page={currentPage}
          />
          <Pagination
            path={path}
            currentPage={currentPage}
            total={numberOfArticles}
            resultsPerPage={resultsPerPage}
          />
        </Wrapper>
      </article>
    </>
  )
}
